package es.subastia.data.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AuctionDataModel(
    val auctionId: String,
    val title: String,
    val description: String? = null,
    val currentPrice: Double? = null,
    val basePrice: Double? = null, // kept for compatibility, map to appraisalValue?
    @SerialName("dateStart") val dateStart: String? = null,
    @SerialName("dateEnd") val dateEnd: String? = null,
    val authority: AuctionAuthorityDataModel? = null,
    val location: String? = null, // city
    val category: String? = null,
    val type: String? = null,
    val offersCount: Int = 0,
    val accountExpediente: String? = null,
    val aiSummary: String? = null,
    val appraisalValue: Double,
    val auctionValue: Double,
    val address: String? = null, // Made nullable per user request
    val code: String? = null, // zipCode or identifier
    val email: String? = null, // Contact email specific to auction if diff from authority
    val fax: String? = null,
    val model: String? = null, // For Vehicles
    val phone: String? = null, // Contact phone specific to auction if diff from authority
    val bidStep: Double? = null,
    val boeAnnouncement: String? = null,
    val boeId: String? = null,
    @SerialName("catastralRef") val catastralRef: String? = null,
    val city: String? = null,
    val claimedAmount: Double,
    val depositAmount: Double,
    val hasLots: Boolean = false,
    val isGoodOpportunity: Boolean = false,
    val lotId: Int? = null,
    val minBid: Double? = null,
    val portalUrl: String,
    val province: String? = null,
    val status: String? = null, // "ACTIVE", etc.
    val updatedAt: String? = null,
    val lots: List<LotDataModel> = emptyList()
) {
    val id: String get() = auctionId
}

@Serializable
data class AuctionAuthorityDataModel(
    val name: String? = null,
    val email: String? = null,
    val phone: String? = null
)
